import { useTranslation } from "react-i18next";
import BottomPanel from "../app/panels/BottomPanel";
import Loader from "../Loader";
import { TopicsInterestsEditor } from "./TopicsInterestsEditor";

/**
 * The standalone "Pick your interests" bottom sheet: title + shared editor in
 * an 85dvh panel. One sheet for every entry point outside the settings stack
 * (the Discovery gear chip, the profile page's interests "Edit") — the host
 * owns the open state. The editor body is mounted only while the sheet is
 * open, so its selection seeds fresh on every open.
 */
function InterestsSheet({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();

  return (
    <BottomPanel
      isOpen={isOpen}
      onClose={onClose}
      displayCloseButton
      height="85dvh"
    >
      {isOpen ? (
        <div className="flex h-full flex-col">
          <h2 className="m-0 shrink-0 px-5 pt-10 pb-3 text-2xl/tight font-semibold tracking-tight text-ds-black">
            {t("Pick your interests")}
          </h2>
          <TopicsInterestsEditor surface="sheet" onSaved={onClose} />
        </div>
      ) : (
        <Loader expanded />
      )}
    </BottomPanel>
  );
}

export { InterestsSheet };
